<template>
  <div class="systemManage">
    <div class="left-div">
      <el-table :data="tableData" border :row-class-name="tableRowClassName">
        <el-table-column prop="name" label="门店类型">
          <template slot-scope="scope">
            <!--            <el-button type="text" size="small" @click="areaConfig(scope.row)">{{scope.row.name}}</el-button>-->
            <div style="cursor: pointer" @click="areaConfig(scope, scope.row.name)">{{ scope.row.name }}</div>
            <!--            <el-link @click="areaConfig(scope.row)">{{scope.row.name}}</el-link>-->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="right-div">
      <el-row style="padding: 8px">
        <el-col :span="22">
          <div class="grid-content bg-purple">陈列区域配置</div>
        </el-col>
        <el-col :span="2" v-if="selectConcept != ''">
          <el-button @click="addAreaName">新建</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="12">
        <el-col :span="8" :offset="0" v-for="(item, index) in tableDetail" :key="item.id" style="margin-top: 10px">
          <el-card shadow="always" class="box-card">
            <template #header>
              <div class="card-header">
                <el-input maxlength="50" v-if="item.isEdit" v-model="item.displayAreaName" v-bind:id="'pid'+index" placeholder="名称" style="line-height: 36px"></el-input>
                <span v-if="!item.isEdit" style="line-height: 36px">{{ item.displayAreaName }}</span>
                <div style="height: 5px;"></div>
                <el-input type="textarea" :rows="3" v-if="item.isEdit" v-model="item.detail" v-bind:id="'pid'+index" placeholder="细则"></el-input>
                <div v-if="!item.isEdit" style="font-size: 12px;white-space: pre-line;height: 80px;">{{ item.detail }}</div>
              </div>
            </template>
            <span class="edit-icon">
              <i v-if="!item.isEdit" class="el-icon-edit" @click="editAreaName(item)"></i>
              <i v-else class="el-icon-success" @click="doAddOrEditAreaName(item)"></i>
              <!--              <i v-if="item.isEdit" class="el-icon-edit" @click="item.isEdit=true;editAreaName(item,index)"></i>-->
              <!--              <i v-else class="el-icon-success" @click="item.isEdit=false;doEditAreaName(item,index)"></i>-->
              <i class="el-icon-delete" @click="delAreaName(item)"></i>
            </span>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

export default {
  name: "SystemManage",
  data() {
    return {
      tableData: [],
      tableDetail: [],
      isDisabled: true,
      selectConcept: "", //当前选中的门店概念
      selectedId: "", //当前选中的门店索引
      selected: null
    }
  },
  computed: {},
  mounted() {
    this.doorList()
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if (rowIndex === this.selectedId) {
        return 'success-row';
      }
      return '';
    },
    // 门店概念列表
    async doorList() {
      let res = await axios.post(vmsReqUrl+"displayAreaConfiguration/List");
      res = res.data
      if (res.code === 200) {
        let tableDataTemp = [];
        res.data.forEach(function (item) {
          let rowData = {name: item};
          tableDataTemp.push(rowData)
        })
        this.tableData = tableDataTemp
      }
    },
    // 区域配置
    async areaConfig(row, name) {
      this.selected = row
      this.selectedId = row.$index
      this.selectConcept = name
      let res = await axios.post(vmsReqUrl+"displayAreaConfiguration/List/" + name);
      res = res.data
      if (res.code === 200) {
        this.tableDetail = res.data
        this.tableDetail.forEach(function (item) {
          item.isEdit = false
        })
      }
    },
    // 编辑区域名称
    editAreaName(item) {
      item.isEdit = true;
      this.$forceUpdate()
    },
    // 新增、编辑区域名称
    async doAddOrEditAreaName(item) {
      if (item.id === -1) { //新增
        await this.doAddAreaName(item)
      } else { //编辑
        await this.doEditAreaName(item)
      }

    },
    // 新增区域名称
    async doAddAreaName(item) {
      item.isEdit = false;
      let param = new FormData();
      param.append("concept", this.selectConcept);
      param.append("displayAreaName", item.displayAreaName);
      param.append("detail", item.detail);
      let res = await axios.post(vmsReqUrl+"displayAreaConfiguration/save", param);
      res = res.data
      if (res.code === 200) {
        await this.areaConfig(this.selected, this.selectConcept)
        this.$message.success(res.message)
      } else {
        // this.$message.warning(res.message)
      }
    },
    // 编辑区域名称
    async doEditAreaName(item) {
      item.isEdit = false;
      let param = new FormData();
      param.append("name", item.displayAreaName)
      param.append("detail", item.detail)
      let res = await axios.put(vmsReqUrl+"displayAreaConfiguration/" + item.id, param);
      res = res.data
      if (res.code === 200) {
        this.$forceUpdate()
        this.$message.success(res.message)
      } else {
        // this.$message.warning(res.message)
      }
    },
    // 删除区域名称
    async delAreaName(row) {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let res = await axios.delete(vmsReqUrl+"displayAreaConfiguration/" + row.id);
          res = res.data
          if (res.code === 200) {
            await this.areaConfig(this.selected, this.selectConcept)
            this.$message.success(res.message)
          } else {
            // this.$message.warning(res.message)
          }
        })
        .catch(_ => {
        })

    },
    // 新增区域名称
    addAreaName() {
      let newArea = {isEdit: true, id: -1};
      this.tableDetail.push(newArea)
    }
  }
}
</script>

<style lang="sass" scoped>
.systemManage
  padding: 20px

  .left-div
    position: fixed
    width: 400px
    overflow: auto
    border-radius: 4px
    border: #606266 1px
    height: calc(100% - 110px)
    background: #fff

  .right-div
    width: calc(100% - 710px)
    height: calc(100% - 120px)
    position: fixed
    margin-left: 440px
    border-radius: 4px
    border: #606266 1px
    padding: 5px
    background-color: white
    overflow: auto

    .edit-icon
      float: right
      padding-bottom: 15px

      i
        padding: 5px
        cursor: pointer
</style>



// WEBPACK FOOTER //
// src/vms/pages/views/SystemManage.vue